import { find, isEmpty } from 'lodash';
import { auth as useAuthStore } from 'src/store/auth';

export default {

  activeSession: (state) => {
    if (state.activeSessionIdPointer === null) {
      return state.primaryActiveSession;
    }
    return find(state.groupSessions, { id: state.activeSessionIdPointer }) || null;
  },

  activeSessionPrograms(state) {
    if (this.activeSession === null) {
      return [];
    }
    return state.loadedActiveSessionPrograms;
  },

  currentVideoCallSession: (state) => {
    const sortedSessions = [...state.activeVideoCallSessions].sort(
      (a, b) => (a?.createTimestamp?.toDate().getTime() ?? 0) - (b?.createTimestamp?.toDate().getTime() ?? 0),
    );

    return find(sortedSessions, { sessionId: state.primaryActiveSession?.id });
  },

  isInvitedUser() {
    if (isEmpty(this.currentVideoCallSession)) {
      return false;
    }

    const auth = useAuthStore();
    const { userDetails } = auth;

    return this.currentVideoCallSession.runBy !== userDetails.userId;
  },

};
